import React from 'react';
import { readStoredView } from '../../lib/view';

function BackIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      <path d="M10 3.5 5.5 8l4.5 4.5" />
    </svg>
  );
}

export function FocusHeader({ onClose }: { onClose: () => void }) {
  const view = readStoredView();
  const backLabel =
    view === 'inbox'
      ? 'Back to Inbox'
      : view === 'archive'
      ? 'Back to Archive'
      : 'Back to Today';

  return (
    <div
      style={{
        height: 52,
        display: 'flex',
        alignItems: 'center',
        padding: '0 20px',
        borderBottom: '1px solid var(--rule)',
        flexShrink: 0,
      }}
    >
      <button
        type="button"
        onClick={onClose}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 10px',
          background: 'transparent',
          border: 'none',
          color: 'var(--ink-soft)',
          fontSize: 13,
          fontFamily: 'var(--font-ui)',
          cursor: 'pointer',
          borderRadius: 6,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'var(--sidebar-hover)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <BackIcon /> {backLabel}
      </button>
    </div>
  );
}
